// Single source of truth for the event summary line, shared by the hero eyebrow and
// the footer so they can't drift, and built from the loaded /conference metadata so
// both track the server's date-shift instead of hard-coding a date.

import { formatDayRange } from "./datetime.js";

export function conferenceSummary(conference) {
  if (!conference) {
    return "";
  }
  const range = formatDayRange(conference.start, conference.end);
  return `${conference.name} ${conference.year} · ${range} · ${conference.city}`;
}
